import React from 'react'
import { Grid, Button, Paper, Table, TableHead, TableCell, TableBody } from '@material-ui/core'
import { connect } from 'react-redux'
import {
  GET_LOSS_REASONS,
  ADD_LOSS_REASON,
  UPDATE_LOSS_REASON,
  DELETE_LOSS_REASON,
} from './GraphQL'
import { useQuery, useLazyQuery, useMutation } from '@apollo/react-hooks'
import { startLoading, stopLoading } from '../../../actions/loading'
import { hasAccess } from '../../../utils/api'
import { formatErrors } from '../../../utils/common'

import LossReasonListItem from './LossReasonListItem'
import EditableHOCWrapper from '../../../containers/HOC/EditableHOC'

import { openErrorMessage, openSuccessMessage } from '../../../actions/message'
import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import ModalDialog from '../../../components/common/ModalDialog'
import AddLossReasonModal from '../../../components/Modal/AddLossReasonModal'

const LossReasonListItemEditable = EditableHOCWrapper(LossReasonListItem)

let columns = ['Reason', '']

const LossReasons = (props) => {
  const permitted = hasAccess()
  const addLossReasonModal = React.useRef(null)
  const deleteModal = React.useRef(null)
  const [lossReasonList, setLossReasonList] = React.useState([])
  const [isUpdateCompleted, setIsUpdateCompleted] = React.useState(false)
  const [selectedItemToDelete, setSelectedItemToDelete] = React.useState({})

  const [lossReasons, resLossReasons] = useLazyQuery(GET_LOSS_REASONS, {
    fetchPolicy: 'cache-and-network',
    onCompleted: (data) => {
      setLossReasonList(data.lossReasons.values)
      props.dispatch(stopLoading())
    },
    onError: (error) => {
      onError(formatErrors(error))
      props.dispatch(stopLoading())
    },
  })

  const [addLossReason, resAddLossReason] = useMutation(ADD_LOSS_REASON, {
    onCompleted: (data) => {
      props.dispatch(stopLoading())
      addLossReasonModal.current.handleClose()
      onSuccess('New loss reason saved')
      fetchApi()
    },
    onError: (error) => {
      onError(formatErrors(error))
      props.dispatch(stopLoading())
    },
  })

  const [updateLossReason, resUpdateLossReason] = useMutation(UPDATE_LOSS_REASON, {
    onCompleted: (data) => {
      setIsUpdateCompleted(true)
      props.dispatch(stopLoading())
      onSuccess('Loss Reason info saved')
    },
    onError: (error) => {
      onError(formatErrors(error))
      props.dispatch(stopLoading())
    },
  })

  const [deleteLossReason, resDeleteLossReason] = useMutation(DELETE_LOSS_REASON, {
    onCompleted: (data) => {
      props.dispatch(stopLoading())
      deleteModal.current.handleClose()
      onSuccess('Loss reason deleted')
      fetchApi()
    },
    onError: (error) => {
      onError(formatErrors(error))
      props.dispatch(stopLoading())
    },
  })

  React.useEffect(() => {
    fetchApi()
  }, [])

  const fetchApi = () => {
    props.dispatch(startLoading())
    setLossReasonList([])
    lossReasons({
      variables: {},
    })
  }

  const onError = (message) => props.dispatch(openErrorMessage(message))
  const onSuccess = (message) => props.dispatch(openSuccessMessage(message))

  const validateLossReason = (data) => {
    if (!data.description) {
      onError('Please enter loss reason description')
      return false
    }
    return true
  }

  const onSave = (data, afterOnSave) => {
    if (validateLossReason(data)) {
      setIsUpdateCompleted(false)
      const input = {
        id: data.id,
        description: data.description,
        active: data.active,
      }
      props.dispatch(startLoading())
      updateLossReason({ variables: { input } })
    }
  }

  const addLossReasonApiCall = (data) => {
    props.dispatch(startLoading())
    addLossReason({ variables: { input: data } })
  }

  const openDeleteModal = (item) => (e) => {
    setSelectedItemToDelete(item)
    deleteModal.current.handleClickOpen()
  }

  const onDeleteItem = (e) => {
    props.dispatch(startLoading())
    deleteLossReason({ variables: { id: selectedItemToDelete.id } })
  }

  return (
    <div>
      <Grid container>
        <Grid className="addButton" item xs={12} sm={12} md={12} lg={12}>
          {permitted ? (
            <Button
              variant="raised"
              className="primary-button pull-right margin-bottom-small"
              onClick={() => addLossReasonModal.current.handleClickOpen()}
            >
              Add Loss Reason
            </Button>
          ) : null}
        </Grid>
      </Grid>
      <Grid container>
        <Grid className="unversalScroll" item xs={12} sm={12} md={12} lg={12}>
          <Paper>
            <div className="table-scroll">
              <Table>
                <TableHead>
                  {columns && columns.map((col) => <TableCell>{col}</TableCell>)}
                </TableHead>
                <TableBody>
                  {lossReasonList &&
                    lossReasonList.length > 0 &&
                    lossReasonList.map((data, index) => (
                      <LossReasonListItemEditable
                        key={index}
                        dataToEdit={data}
                        onSave={onSave}
                        isUpdateCompleted={isUpdateCompleted}
                        onDelete={openDeleteModal(data)}
                      />
                    ))}
                </TableBody>
              </Table>
            </div>
          </Paper>
        </Grid>
      </Grid>
      <AddLossReasonModal
        ref={addLossReasonModal}
        addLossReason={addLossReasonApiCall}
        onError={onError}
      />
      <ModalDialog ref={deleteModal} onConfirm={onDeleteItem} confirmText="delete">
        Are you sure you want to delete the loss reason
      </ModalDialog>
    </div>
  )
}

export default connect(({ dispatch, shopReducer }) => ({
  dispatch,
  shopReducer,
}))(ContainerWithTitle(LossReasons, 'Loss Reasons'))



// WEBPACK FOOTER //
// ./src/containers/Settings/Manufacturing/LossReasons.js